import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'

import RanRoom from './ran-room'
import { ContentBox, Button } from '@portal/kit/pkg/components'

import styles from './ran-style'

// TODO: uncomment in a while
// import classNames from 'classnames'
// const Guide = props => {
//   const classes = styles(props.theme)
//   return (
//     <ContentBox>
//       <a href="/ran/help" className={classes.helpButton}>
//         <span className={classNames('fal', 'fa-question-circle', classes.helpButtonIcon)}/>
//         {props.t('ran_list.guide')}
//         <span className={classNames('fal', 'fa-chevron-right', classes.helpButtonArrow)}/>
//       </a>
//     </ContentBox>
//   )
// }

const Ran = ({ theme, t, rooms, canActivateRan, activateRan}) => {
  const classes = styles(theme)

  return (
    <Fragment>
      {rooms.map(room => <RanRoom key={room.id} data={room} />)}
      {canActivateRan &&
        <ContentBox>
          <div className={classes.activateWrapper}>
            <div>
              <p className={classes.activateTitle}>{t('ran_activate_2.title')}</p>
              <p className={classes.activateText}>{t('ran_activate_2.description')}</p>
            </div>
            <p className={classes.activateAction}>
              <Button onClick={activateRan}>{t('ran_activate_2.button')}</Button>
            </p>
          </div>
        </ContentBox>
      }
    </Fragment>
  )
}

Ran.propTypes = {
  portalConfiguration: PropTypes.object,
  theme: PropTypes.object.isRequired,
  activateRan: PropTypes.func.isRequired,
}

export default compose(
  withTranslation(),
  withTheme
)(Ran)
